var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-login"},[_c('img',{staticClass:"logo my-4",attrs:{"src":require("@/assets/images/logo-vertical.png"),"alt":"Logo Mercurio RFF"}}),_c('LoginForm',{staticClass:"card-body"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }